import { render, staticRenderFns } from "./NfToken.vue?vue&type=template&id=5c2eb2d5&scoped=true&"
import script from "./NfToken.vue?vue&type=script&lang=js&"
export * from "./NfToken.vue?vue&type=script&lang=js&"
import style0 from "./NfToken.vue?vue&type=style&index=0&id=5c2eb2d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2eb2d5",
  null
  
)

export default component.exports